import PasswordInput from '../components/PasswordInput';
import React, { useState, useEffect } from 'react';
import axios from 'axios';

const YeniPersonelPage = ({ geriDon }) => {
  const [form, setForm] = useState({
    ad: '', soyad: '', email: '', sifre: '',
    telefon: '', departman: '', pozisyon: '', rol: 'personel',
    outsource: 0, outsource_firma: '', outsource_baslangic: '',
    calisma_sekli: 'ofis'
  });
  const [roller, setRoller] = useState([]);
  const [sonuc, setSonuc] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(false);

  useEffect(() => {
    axios.get('/api/admin/roller-listesi').then(r => setRoller(r.data)).catch(console.error);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault(); setYukleniyor(true); setSonuc(null);
    try {
      await axios.post('/api/admin/kullanicilar', form);
      setSonuc({ tip: 'basari', mesaj: 'Personel basariyla eklendi!' });
      setTimeout(() => geriDon && geriDon(), 1500);
    } catch(err) { setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Hata olustu.' }); }
    finally { setYukleniyor(false); }
  };

  const f = (alan, deger) => setForm({ ...form, [alan]: deger });

  const SectionBaslik = ({ ikon, baslik, aciklama }) => (
    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '1.25rem', paddingBottom: '1rem', borderBottom: '1px solid var(--border)' }}>
      <div style={{ width: '36px', height: '36px', borderRadius: '8px', background: 'var(--mavi-acik)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px', flexShrink: 0 }}>{ikon}</div>
      <div>
        <div style={{ fontSize: '14px', fontWeight: '600', color: 'var(--yazi)' }}>{baslik}</div>
        {aciklama && <div style={{ fontSize: '12px', color: 'var(--yazi-ikincil)' }}>{aciklama}</div>}
      </div>
    </div>
  );

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '1.5rem' }}>
        <button type="button" className="btn btn-secondary btn-sm" onClick={geriDon}>← Listeye Don</button>
        <div>
          <h2 style={{ fontSize: '22px', marginBottom: '2px' }}>Yeni Personel Ekle</h2>
          <p style={{ fontSize: '13px', color: 'var(--yazi-ikincil)' }}>Sisteme yeni personel kaydi olusturun.</p>
        </div>
      </div>

      {sonuc && <div className={'alert alert-' + (sonuc.tip === 'basari' ? 'success' : 'error')} style={{ marginBottom: '1.5rem' }}>{sonuc.mesaj}</div>}

      <form onSubmit={handleSubmit}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem', marginBottom: '1.5rem' }}>

          {/* Kimlik Bilgileri */}
          <div className="card">
            <SectionBaslik ikon="👤" baslik="Kimlik Bilgileri" aciklama="Temel hesap bilgileri" />
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                <div className="form-group">
                  <label>Ad *</label>
                  <input type="text" value={form.ad} onChange={e => f('ad', e.target.value)} required autoComplete="off" />
                </div>
                <div className="form-group">
                  <label>Soyad *</label>
                  <input type="text" value={form.soyad} onChange={e => f('soyad', e.target.value)} required autoComplete="off" />
                </div>
              </div>
              <div className="form-group">
                <label>E-posta *</label>
                <input type="email" value={form.email} onChange={e => f('email', e.target.value)} required autoComplete="off" />
              </div>
              <div className="form-group">
                <label>Sifre *</label>
                <PasswordInput value={form.sifre} onChange={e => f('sifre', e.target.value)} required minLength={6} autoComplete="new-password" />
              </div>
              <div className="form-group">
                <label>Telefon</label>
                <input type="tel" value={form.telefon} onChange={e => f('telefon', e.target.value)} autoComplete="off" />
              </div>
              <div className="form-group">
                <label>Rol</label>
                <select value={form.rol} onChange={e => f('rol', e.target.value)}>
                  {roller.filter(r => r.anahtar !== 'admin').map(r => (
                    <option key={r.anahtar} value={r.anahtar}>{r.baslik}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          {/* Is Bilgileri */}
          <div className="card">
            <SectionBaslik ikon="💼" baslik="Is Bilgileri" aciklama="Departman ve calisma bilgileri" />
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                <div className="form-group">
                  <label>Departman</label>
                  <input type="text" value={form.departman} onChange={e => f('departman', e.target.value)} autoComplete="off" />
                </div>
                <div className="form-group">
                  <label>Pozisyon</label>
                  <input type="text" value={form.pozisyon} onChange={e => f('pozisyon', e.target.value)} autoComplete="off" />
                </div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                <div className="form-group">
                  <label>Calisma Sekli</label>
                  <select value={form.calisma_sekli} onChange={e => f('calisma_sekli', e.target.value)}>
                    <option value="ofis">🏢 Ofisten</option>
                    <option value="remote">🏠 Remote</option>
                    <option value="hibrit">🔄 Hibrit</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Calisma Turu</label>
                  <select value={form.outsource} onChange={e => setForm({ ...form, outsource: parseInt(e.target.value), outsource_firma: '', outsource_baslangic: '' })}>
                    <option value={0}>🏠 Inhouse</option>
                    <option value={1}>🤝 Outsource</option>
                  </select>
                </div>
              </div>

              {form.outsource === 1 && (
                <div style={{ padding: '1rem', background: 'var(--gri-50)', borderRadius: 'var(--radius-sm)', border: '1px solid var(--border)' }}>
                  <div style={{ fontSize: '12px', fontWeight: '600', color: 'var(--yazi-ikincil)', marginBottom: '0.75rem', textTransform: 'uppercase' }}>Outsource Detaylari</div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                    <div className="form-group">
                      <label>Firma</label>
                      <input type="text" value={form.outsource_firma} onChange={e => f('outsource_firma', e.target.value)} autoComplete="off" />
                    </div>
                    <div className="form-group">
                      <label>Baslangic Tarihi</label>
                      <input type="date" value={form.outsource_baslangic} onChange={e => f('outsource_baslangic', e.target.value)} />
                    </div>
                  </div>
                </div>
              )}

              {/* Ozet */}
              <div style={{ marginTop: 'auto', padding: '1rem', background: 'var(--mavi-acik)', borderRadius: 'var(--radius-sm)' }}>
                <div style={{ fontSize: '12px', color: 'var(--mavi)', fontWeight: '600', marginBottom: '8px' }}>Ozet</div>
                <div style={{ fontSize: '13px', color: 'var(--mavi)', display: 'flex', flexDirection: 'column', gap: '4px' }}>
                  {form.ad && <span>👤 {form.ad} {form.soyad}</span>}
                  {form.email && <span>✉️ {form.email}</span>}
                  {form.departman && <span>🏢 {form.departman}{form.pozisyon ? ' · ' + form.pozisyon : ''}</span>}
                  <span>🔑 {roller.find(r => r.anahtar === form.rol)?.baslik || form.rol}</span>
                  <span>{form.outsource === 1 ? '🤝 Outsource' : '🏠 Inhouse'} · {form.calisma_sekli === 'ofis' ? 'Ofisten' : form.calisma_sekli === 'remote' ? 'Remote' : 'Hibrit'}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div style={{ display: 'flex', gap: '8px' }}>
          <button type="submit" className="btn btn-primary" disabled={yukleniyor} style={{ minWidth: '140px' }}>
            {yukleniyor ? 'Kaydediliyor...' : '✓ Personel Ekle'}
          </button>
          <button type="button" className="btn btn-secondary" onClick={geriDon}>Iptal</button>
        </div>
      </form>
    </div>
  );
};
export default YeniPersonelPage;
